if (!Promise.allSettled) {
	Promise.allSettled = function <T>(
		promises: Array<Promise<T>>
	): Promise<Array<PromiseSettledResult<T>>> {
		return Promise.all(
			promises.map(promise =>
				Promise.resolve(promise)
					.then(
						value =>
							({ status: 'fulfilled', value }) as PromiseFulfilledResult<T>
					)
					.catch(
						reason => ({ status: 'rejected', reason }) as PromiseRejectedResult
					)
			)
		);
	};
}
